import * as React from "react";
import { Text } from "react-native";

interface TitleProps {
  text: string;
}

export default function TitleXl(props: TitleProps) {
  return (
    <Text className="text-blue1 text-xl text-center font-medium">
      {props.text}
    </Text>
  );
}
